import React from 'react';

import { SectionTitle } from '../SectionTitle/SectionTitle';
import { KpiTile, KpiGrid } from '../KpiTile/KpiTile';
import type { Kpi } from '../../mock-data/types';
import type { IconName } from '../Icon/Icon';
import { Section } from './KpiSection.styles';

export type KpiSectionProps = {
  title: string;
  kpis: Kpi[];
  icon?: IconName;
  iconColor?: string;
  /** While true, every tile's figures + delta badges show placeholders (loading). */
  loading?: boolean;
};

/**
 * A titled, responsive grid of KPI tiles. The tiles carry their own surface, so
 * the section sits directly on the page (a section title above the grid, no
 * panel). Used by the Running-Campaign performance section.
 */
export const KpiSection = ({ title, kpis, icon, iconColor, loading = false }: KpiSectionProps): React.ReactElement => (
  <Section>
    <SectionTitle title={title} icon={icon} iconColor={iconColor} />
    <KpiGrid>
      {kpis.map((kpi) => (
        <KpiTile key={kpi.id} kpi={kpi} loading={loading} />
      ))}
    </KpiGrid>
  </Section>
);

export default KpiSection;
